import { render } from "./Infotop.vue?vue&type=template&id=08679685&scoped=true"
import script from "./Infotop.vue?vue&type=script&lang=js"
export * from "./Infotop.vue?vue&type=script&lang=js"

import "./Infotop.vue?vue&type=style&index=0&id=08679685&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08679685"

export default script